import { useEffect, useState } from "react";
import {
  Nullable,
  useAdminRegionV2ControllerGetRegionsPaginated,
} from "service";
import { ControlledSelectOption } from "ui";
import { SortOptions } from "../pages/dashboard/components/generic-table/generic-table";
import { AdminRegionResDto } from "service/api/estabrookSchemas";

const useRegions = ({
  sort,
  regionId,
}: {
  sort?: Nullable<SortOptions>;
  regionId?: string;
}) => {
  const [select, setSelect] = useState<ControlledSelectOption[]>([]);
  const { isLoading, refetch, data } =
    useAdminRegionV2ControllerGetRegionsPaginated({
      queryParams: {
        sort: sort?.sortBy as
          | "addressCount"
          | "updatedAt"
          | "totalServiceDurationInSeconds"
          | undefined,
        order: sort?.direction,
      },
    });

  useEffect(() => {
    if (data && data?.data?.length) {
      setSelect(
        data?.data.reduce(
          (acc: ControlledSelectOption[], region: AdminRegionResDto) => {
            if (regionId && regionId === region.id) {
              return acc;
            }
            acc.push({
              label: region.name,
              value: region.id,
            });
            return acc;
          },
          [] as ControlledSelectOption[],
        ),
      );
    }
  }, [data]);

  return { isLoading, refetch, data, select };
};

export default useRegions;
